import React from 'react';
import { FilterKAI } from 'components/Icons';
import './MobileKai.scss';

type Props = {
  trace?: boolean;
};

function MobileKai({ trace }: Props): JSX.Element {
  return (
    <div className="MobileKai">
      <div className="MobileKai-icon">
        <FilterKAI />
      </div>
      <h1 className="MobileKai-title">KAI Assistant - Coming Soon</h1>
      <p className="MobileKai-description">
        KitchenSync AI is currently under development. Soon you'll be able to interact with our intelligent assistant to
        help manage your requests, answer questions, and provide insights about your data.
      </p>
    </div>
  );
}

export default MobileKai;
